export default __webpack_public_path__ + "static/media/2047.ae413a27.png";